// extracted by mini-css-extract-plugin
module.exports = {"section":"Aa_CUACU","wrapper":"GFK0FDRW","title":"WHzIrEhp","description":"_1iCwUf1","mobile":"_F259DvO"};